import { apiQuery } from '../';

export const atsApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      bulkInvite: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ payload }) => {
          return {
            method: 'post',
            url: '/account_invitations/bulk',
            data: { account_invitations: payload },
          };
        },
      }),

      invites: builder.query({
        transformResponse: (response) => response.data?.account_invitations,
        query: () => {
          return {
            method: 'get',
            url: '/account_invitations',
          };
        },
      }),

      users: builder.query({
        transformResponse: (response) => response.data,
        query: ({ params }) => {
          return {
            method: 'get',
            url: '/users',
            params,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useBulkInviteMutation,
  useInvitesQuery,
  useUsersQuery,
  useLazyUsersQuery,
} = atsApi;
